import React from 'react';

import {
  Header as ChartsHeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  MobileWrapper,
  IconWrapper,
  SmallTitle,
  GoToTitle,
  Title,
} from './ChartsHeader.style';
import { ReactComponent as DSPChartsIcon } from 'icons/dsp-charts-header-icon.svg';
import { ReactComponent as OfficialChartsIcon } from 'icons/official-charts-header-icon.svg';
import Anchor from 'components/base/Anchor/Anchor';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

interface IChartsHeaderProps {
  chartInfo: any;
  topicEntityType: 'Official Charts' | 'DSP Charts';
}

const ChartsHeader: React.FC<IChartsHeaderProps> = (props) => {
  const { chartInfo, topicEntityType } = props;
  const isChartOfficial = topicEntityType === 'Official Charts';
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header inView={inview} withVerticalBackground>
          <TopBar
            topicEntityType={topicEntityType}
            inView={inview}
            isSticky
            chartInfo={chartInfo}
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <ChartsHeaderWrapper>
                <IconWrapper>
                  {isChartOfficial ? <OfficialChartsIcon /> : <DSPChartsIcon />}
                </IconWrapper>
                <ContentWrapper data-pw="header-entity-metadata">
                  <SmallTitle>Charts</SmallTitle>
                  <MobileWrapper>
                    <Title>{topicEntityType}</Title>
                    <GoToTitle onClick={(e): void => e.preventDefault()}>
                      <Anchor
                        withChevron
                        withoutFocus
                        to={`/chart/${isChartOfficial ? 'dsp' : 'official'}`}
                      >
                        Go to{' '}
                        {isChartOfficial ? 'DSP Charts' : 'Official Charts'}
                      </Anchor>
                    </GoToTitle>
                  </MobileWrapper>
                </ContentWrapper>
              </ChartsHeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default ChartsHeader;
